'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _PropTypes = require('../utils/PropTypes');

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _context = require('../util/context');

var _context2 = _interopRequireDefault(_context);

var _reactVirtualized = require('react-virtualized');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var InfiniteList = (_temp2 = _class = function (_PureComponent) {
  _inherits(InfiniteList, _PureComponent);

  function InfiniteList() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, InfiniteList);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = InfiniteList.__proto__ || Object.getPrototypeOf(InfiniteList)).call.apply(_ref, [this].concat(args))), _this), _this.handeRef = function (c, callback) {
      _this.List = c;
      return callback(c);
    }, _this.recomputeRowHeights = function () {
      if (_this.List && _this.List.recomputeRowHeights) _this.List.recomputeRowHeights();
    }, _this.List = {}, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(InfiniteList, [{
    key: 'componentDidUpdate',
    value: function () {
      function componentDidUpdate(prevProps) {
        var prevRowCount = prevProps.rowCount;
        var _props = this.props,
            thisRowCount = _props.rowCount,
            rowHeight = _props.rowHeight;


        if (rowHeight instanceof Function && prevRowCount !== thisRowCount) {
          this.recomputeRowHeights();
        }
      }

      return componentDidUpdate;
    }()
  }, {
    key: 'render',
    value: function () {
      function render() {
        var _this2 = this;

        var _props2 = this.props,
            isRowLoaded = _props2.isRowLoaded,
            loadMoreRows = _props2.loadMoreRows,
            maxHeight = _props2.maxHeight,
            minHeight = _props2.minHeight,
            minimumBatchSize = _props2.minimumBatchSize,
            rowCount = _props2.rowCount,
            threshold = _props2.threshold,
            totalRowCount = _props2.totalRowCount,
            scrollElement = _props2.scrollElement;


        return _react2['default'].createElement(
          _reactVirtualized.InfiniteLoader,
          {
            isRowLoaded: isRowLoaded,
            loadMoreRows: loadMoreRows,
            minimumBatchSize: minimumBatchSize,
            threshold: threshold,
            rowCount: totalRowCount || rowCount
          },
          function (_ref2) {
            var onRowsRendered = _ref2.onRowsRendered,
                registerChild = _ref2.registerChild;
            return _react2['default'].createElement(
              _reactVirtualized.WindowScroller,
              { scrollElement: scrollElement },
              function (_ref3) {
                var height = _ref3.height,
                    isScrolling = _ref3.isScrolling,
                    onChildScroll = _ref3.onChildScroll,
                    scrollTop = _ref3.scrollTop;
                return _react2['default'].createElement(
                  _reactVirtualized.AutoSizer,
                  { disableHeight: true },
                  function (_ref4) {
                    var width = _ref4.width;
                    return _react2['default'].createElement(_reactVirtualized.List, _extends({
                      ref: function () {
                        function ref(c) {
                          return _this2.handeRef(c, registerChild);
                        }

                        return ref;
                      }(),
                      autoHeight: true,
                      onRowsRendered: onRowsRendered,
                      width: width,
                      height: Math.max(minHeight, Math.min(maxHeight, height)),
                      scrollTop: scrollTop,
                      onScroll: onChildScroll,
                      isScrolling: isScrolling
                    }, _this2.props));
                  }
                );
              }
            );
          }
        );
      }

      return render;
    }()
  }]);

  return InfiniteList;
}(_react.PureComponent), _class.propTypes = {
  /*
   * The maximum list height to render in pixels
   */
  maxHeight: _PropTypes2['default'].number,
  /*
   * The minimum list height to render in pixels
   */
  minHeight: _PropTypes2['default'].number,
  /*
   * The total number of rows in the list
   */
  totalRowCount: _PropTypes2['default'].number,

  // <InfiniteLoader> Props:

  /**
   * Function responsible for tracking the loaded state of each row.
   * It should implement the following signature: ({ index: number }): boolean
   */
  isRowLoaded: _PropTypes2['default'].func.isRequired,

  /**
   * Callback to be invoked when more rows must be loaded.
   * It should implement the following signature: ({ startIndex, stopIndex }): Promise
   * The returned Promise should be resolved once row data has finished loading.
   * It will be used to determine when to refresh the list with the newly-loaded data.
   * This callback may be called multiple times in reaction to a single scroll event.
   */
  loadMoreRows: _PropTypes2['default'].func.isRequired,

  /**
   * Minimum number of rows to be loaded at a time.
   * This property can be used to batch requests to reduce HTTP requests.
   */
  minimumBatchSize: _PropTypes2['default'].number,

  /**
   * Number of rows in list; can be arbitrary high number if actual number is unknown.
   */
  rowCount: _PropTypes2['default'].number,

  /**
   * Threshold at which to pre-fetch data.
   * A threshold X means that data will start loading when a user scrolls within X rows.
   * This value defaults to 15.
   */
  threshold: _PropTypes2['default'].number,

  // <List> Props:

  /**
   * Removes fixed height from the scrollingContainer so that the total height
   * of rows can stretch the window. Intended for use with WindowScroller
   */
  autoHeight: _PropTypes2['default'].bool,

  /** Optional CSS class name */
  className: _PropTypes2['default'].string,

  /**
   * Used to estimate the total height of a List before all of its rows have actually been measured.
   * The estimated total height is adjusted as rows are rendered.
   */
  estimatedRowSize: _PropTypes2['default'].number,

  /** Height constraint for list (determines how many actual rows are rendered) */
  height: _PropTypes2['default'].number,

  /** Optional renderer to be used in place of rows when rowCount is 0 */
  noRowsRenderer: _PropTypes2['default'].func,

  /**
   * Callback invoked with information about the slice of rows that were just rendered.
   * ({ startIndex, stopIndex }): void
   */
  onRowsRendered: _PropTypes2['default'].func,

  /**
   * Callback invoked whenever the scroll offset changes within the inner scrollable region.
   * This callback can be used to sync scrolling between lists, tables, or grids.
   * ({ clientHeight, scrollHeight, scrollTop }): void
   */
  onScroll: _PropTypes2['default'].func,

  /** See Grid#overscanIndicesGetter */
  overscanIndicesGetter: _PropTypes2['default'].func,

  /**
   * Number of rows to render above/below the visible bounds of the list.
   * These rows can help for smoother scrolling on touch devices.
   */
  overscanRowCount: _PropTypes2['default'].number,

  /**
   * Either a fixed row height (number) or a function that returns the height of a row given its index.
   * ({ index: number }): number
   */
  rowHeight: _PropTypes2['default'].oneOfType([_PropTypes2['default'].number, _PropTypes2['default'].func]).isRequired,

  /** Responsible for rendering a row given an index; ({ index: number }): node */
  rowRenderer: _PropTypes2['default'].func.isRequired,

  /** Element to use when triggering scroll events. Uses `window` by default */
  scrollElement: _PropTypes2['default'].object.isRequired,

  /** See Grid#scrollToAlignment */
  scrollToAlignment: _PropTypes2['default'].oneOf(['auto', 'end', 'start', 'center']),

  /** Row index to ensure visible (by forcefully scrolling if necessary) */
  scrollToIndex: _PropTypes2['default'].number,

  /** Vertical offset. */
  scrollTop: _PropTypes2['default'].number,

  /** Tab index for focus */
  tabIndex: _PropTypes2['default'].number,

  /** Width of list */
  width: _PropTypes2['default'].number
}, _class.defaultProps = {
  minHeight: 0,
  scrollElement: _context2['default']
}, _temp2);
exports['default'] = InfiniteList;


InfiniteList.displayName = 'InfiniteList';


//////////////////
// WEBPACK FOOTER
// ../node_modules/@catalytic/pushbot-ui/List/InfiniteList.js
// module id = 1747
// module chunks = 32